import React from 'react';
import { SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import * as actions from '../../Actions/bankfeeds';
import SetPasswordForm from './SetPasswordForm';

class SetPassword extends React.Component {
  componentDidMount() {
    this.props.validatePasswordToken(this.props.match.params);
  }

  submit = ({ password, confirmPassword }) => {
    if (password === undefined) {
      throw new SubmissionError({
        password: "Enter a password"
      });
    }
    if (confirmPassword === undefined) {
      throw new SubmissionError({
        confirmPassword: "Enter a confirm password"
      });
    }
    if (password !== confirmPassword) {
      throw new SubmissionError({
        confirmPassword: "Passwords must match"
      });
    }
    if (password.length < 8) {
      throw new SubmissionError({
        password: "Password must be at least 8 characters"
      });
    }
    this.props.setPassword(this.props.match.params, password);
  };

  render() {

    return (
      <div>
        <SetPasswordForm
          username={this.props.match.params.username}
          onSubmit={this.submit}
        />
      </div>
    );
  }
}

export default connect(
  null,
  actions
)(SetPassword);



// WEBPACK FOOTER //
// ./src/components/Portal/SetPassword.js